<template>
    <v-form-group class="video-field"
                  :label="label"
                  :description="description"
                  :error="error"
                  :state="errorState">
        <div v-if="readonly" v-html="input"></div>
        <vue-editor
            v-else
            :id="id"
            :class="{'form-control': true, 'h-auto': true, 'is-invalid': state == 'invalid'}"
            @input="handleInput"
            :readonly="readonly"
            :editor-toolbar="toolbar"
            :value="input"
            ref="editor"
        />
    </v-form-group>
</template>

<script>
    import {VueEditor} from "vue2-editor"
    import field from "../../Mixins/field"
    import uniqid from 'uniqid'

    export default {
        mixins: [field],
        components: {VueEditor},
        data()
        {
            return {
                id: '',
                cleanOnEnter: true,
                toolbar: [
                    ["bold", "italic", "underline", "strike"],
                    ["blockquote", "code-block", "link"],
                    [{header: [1, 2, 3, 4, 5, 6, false]}],
                    [{list: "ordered"}, {list: "bullet"}]
                ]
            }
        },
        created()
        {
            this.id = uniqid()
        },
        methods: {
            handleInput(input)
            {
                this.$emit('input', input)
            },
        }
    }
</script>
